import { Button } from "@/components/ui/button";
import { Clock, Lock, CreditCard } from "lucide-react";
import { useI18n } from "@/i18n/i18n";

const money = (n, c = "USD") => `${c === "USD" ? "$" : ""}${Number(n || 0).toFixed(2)}`;

/** Franja de estado del pase de WSS Live. No se muestra a estudiantes regulares. */
export const LivePassBanner = ({ pass }) => {
  const { t } = useI18n();
  if (!pass?.has_pass || pass.status === "active") return null;

  const precio = money(pass.price, pass.currency);
  const pagar = pass.payment_link ? (
    <a href={pass.payment_link} target="_blank" rel="noopener noreferrer">
      <Button className="rounded-full bg-white text-slate-900 hover:bg-white/90 font-semibold text-sm px-5"
              data-testid="live-pass-pay-btn">
        <CreditCard className="h-4 w-4" /> {t("lp_pay", { price: precio })}
      </Button>
    </a>
  ) : null;

  const franja = (extra, icono, texto, testid) => (
    <div className={`px-5 py-4 ${extra}`} data-testid={testid}>
      <div className="max-w-5xl mx-auto flex flex-wrap items-center justify-center gap-4 text-center sm:text-left sm:justify-start">
        {icono}
        <p className="text-base md:text-lg flex-1 min-w-[260px] leading-snug">{texto}</p>
        {pagar}
      </div>
    </div>
  );

  if (pass.status === "blocked" || pass.status === "cancelled") {
    return franja(
      "bg-rose-700 text-white",
      <Lock className="h-5 w-5 shrink-0" />,
      <><b>{t("lp_blocked_title")}</b> {t("lp_blocked_text")}</>,
      "live-pass-banner-blocked",
    );
  }

  if (pass.status === "pending_payment") {
    return franja(
      "bg-amber-500 text-amber-950",
      <Clock className="h-5 w-5 shrink-0" />,
      <><b>{t("lp_pending_title")}</b> {t("lp_pending_text", { price: precio })}</>,
      "live-pass-banner-pending",
    );
  }

  const dias = pass.trial_days_left;
  const clave = dias === 0 ? "lp_trial_last_day" : dias === 1 ? "lp_trial_one_day" : "lp_trial_days";
  return franja(
    "bg-gradient-to-r from-teal-600 via-teal-500 to-emerald-500 text-white",
    <Clock className="h-5 w-5 shrink-0" />,
    <span className="font-medium">{t(clave, { n: dias, price: precio })}</span>,
    "live-pass-banner-trial",
  );
};
